export default "__VITE_ASSET__Cpq9Si6x__"